(function ($){
    /**
     * Product Slider for Front Page
     */
    $('.section__icons').each(function (){
        const $section = $(this)
        const $toggles = $section.children()
        const $toggleImages = $section.parents('.section__row').eq(0).find('.showcase__image')

        $toggles.each(function(index, toggle) {
            const $toggle = $(toggle)

            $toggle.on('click', function () {
                if ($toggle.hasClass('_active')) {
                    return false
                }

                $toggle
                    .addClass('_active')
                    .siblings().removeClass('_active')

                $toggleImages
                    .eq(index).removeClass('_hidden')
                    .siblings().addClass('_hidden')
            })
        })
    })
})(jQuery)